const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/pressure-seal-elements`,
    saveCostsTable: `${API_URL}/pressure-seal-element/save-costs-table`,
    saveDiscountTable: `${API_URL}/pressure-seal-element/save-discount-table`
};

export default apiUrls;
